export enum BubbleVariant {
  Default,
  DefaultWithCount,
  Active,
  ActiveWithCount,
}
